<template>
  <div>
    <div
      v-if="hideChildTable == false"
      :style="{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px'
      }"
    >
      <h4 :style="{ margin: 0 }">Units</h4>
      <b-button class="is-rounded" type="is-primary" @click="addUnitGroupUnit">
        Add Unit
      </b-button>
    </div>
    <ModernTable height="initial" condensed :columns="columns" :rows="rows" :useLoader="false" />
  </div>
</template>

<script>
import ModernTable from '@/components/tables/Modern/Table2'
import { methods } from './keys/methods'
import { mounted } from './keys/mounted'

export default {
  components: {
    ModernTable
  },
  props: {
    unitGroupUnits: {
      type: Array,
      default: () => {
        return []
      }
    },
    loadUpdateUnitGroupUnit: Function,
    confirmDeleteUnitGroupUnit: Function,
    addUnitGroupUnit: Function,
    unitGroupID: Number,
    hideChildTable: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      transition: true,
      columns: [
        {
          field: 'lotNumber',
          label: 'Lot',
          width: '20%'
        },
        {
          field: 'name',
          label: 'Unit Name',
          width: '70%'
        },
        {
          field: 'actions',
          label: 'Actions',
          width: '10%'
        }
      ],
      rows: [],
      loading: false,
      pageCount: []
    }
  },
  methods,
  watch: {
    unitGroupUnits: function() {
      this.updateRows()
    }
  },
  mounted
}
</script>

<style>
.centerpreview {
  white-space: normal;
  text-align: center;
  width: 50px;
}
</style>
